import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  @Input() body: string;
  @Input() title: string;
  @Input() id: number;
  @Input() user: any;

  constructor(protected ref: NbDialogRef<ConfirmationDialogComponent>) {
  }

  cancel() {
    this.ref.close(false);
  }

  remove() {
    this.ref.close(true);
  }

}
